export function spotTitleId(spotId: string) {
  return `${spotId}__title`;
}
